import * as appActions from '../../store/app/actions'
import * as searchActions from '../../store/search/actions'
import {connect} from 'react-redux'
import SearchPanel from '../../components/search-page/search-panel'

function mapStateToProps (state) {
  return {
    ...state.myForms.search,
    countryList: state.app.accessCountries.search,
    countryLoader: state.app.countryLoader,
  }
}

export default connect(mapStateToProps, {...searchActions, ...appActions})(SearchPanel)



// WEBPACK FOOTER //
// ./src/containers/search/search-panel-container.js